// src/components/Home/BrandLogoSection.jsx
import { useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

// Swiper styles
import "swiper/css";
import "swiper/css/autoplay";
import { brandLogos } from "../../config/homePageUtils";
import { useLanguage } from "../LanguageProvider/LanguageProvider";

const BrandLogoSection = () => {
  const swiperRef = useRef(null);
  const { language } = useLanguage();

  // Ensure autoplay starts in React 18 strict mode
  useEffect(() => {
    if (swiperRef.current) {
      swiperRef.current.autoplay.start();
    }
  }, []);

  return (
    <section className="py-16 bg-white brand-logo">
      <div className="mx-auto px-16">
        {/* Title */}
        <div className="flex items-center justify-center mb-10">
          <div className="flex-grow h-px bg-gray-300"></div>
          <h2 className="mx-6 text-lg font-semibold text-gray-800 text-center whitespace-nowrap">
            {language
              ? "उत्तराखण्ड में अग्रणी ब्रांड्स की उपस्थिति"
              : "Presence of Leading Brands in Uttarakhand"}
          </h2>
          <div className="flex-grow h-px bg-gray-300"></div>
        </div>

        {/* Swiper */}
        <Swiper
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          modules={[Autoplay]}
          slidesPerView={5}
          spaceBetween={8}
          loop={true}
          loopAdditionalSlides={brandLogos.length} // ⭐ important
          speed={5500}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          allowTouchMove={false} // ⭐ prevents pause
          breakpoints={{
            320: { slidesPerView: 2, spaceBetween: 6 },
            640: { slidesPerView: 3, spaceBetween: 8 },
            1024: { slidesPerView: 5, spaceBetween: 10 },
          }}
        >
          {brandLogos.map((logo, idx) => (
            <SwiperSlide key={idx} className="flex justify-center">
              <div className="shadow-md rounded-lg bg-white w-56 h-28 flex items-center justify-center">
                <img
                  src={logo.src}
                  alt={logo.alt}
                  className="max-h-16 w-auto object-contain"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default BrandLogoSection;
